import React, { Component } from 'react';

export default class ChangelogWidget404 extends Component {
  render() {
    return (
      <div>
        <span>Page not found.</span>
      </div>
    );
  }
}
